import React, { useEffect } from 'react';
// import { Gps, Home, Location, SearchNormal1, UsdCoin } from 'iconsax-react';
// import propertyImage from '../../Assets/Images/propertyImage.png';
import { Link } from 'react-router-dom';
import { useProperty } from '../../Services/hooks/PropertyCoOwn';
import { PageLoader } from '../../Components/Loader/pageLoader';
import { User } from '../../Storeredux/constants/actionTypes';
import { formatCurrency } from '../../Utils/currencyFormat';
import { ReactComponent as Bed } from '../../Assets/Icons/bedcardIcon.svg';
import { ReactComponent as Shower } from '../../Assets/Icons/ShowerIcon.svg';
import { ReactComponent as Toilet } from '../../Assets/Icons/toiletIcon.svg';
import { CustomSearch } from '../../Components/Form/CustomSearch';
import { Pagination } from '../../Components/Pagination/pagination';
import { StorageBaseURL } from '../../Services/constant/Action';

function Buy() {
  const { getBuyProperties, loading: pageLoading, property, paginate, getFilteredPropertyData, error } = useProperty();

  const handleSearch = async (params: any) => {
    await getFilteredPropertyData(params);
  };

  useEffect(() => {
    getBuyProperties({ type: 'mortgage' });
  }, []);
  return (
    <div className='py-9'>
      <div className='text-center '>
        <div className={'lg:w-11/12 mx-auto bg-[#D9FCD5] rounded-xl py-7 flex flex-col gap-3.5 lg:px-16 px-8'}>
          <CustomSearch onSearch={handleSearch} />
          {error && (<p className='text-sm text-red-900 italic pt-1'>
            {error}
          </p>)}
        </div>
      </div>
      <div className='rounded-3xl w-11/12 mx-auto py-4 '>
        {pageLoading ?
          <div className='gap-7 w-fit justify-center mx-auto mt-7 flex flex-wrap h-52'>
            <PageLoader />
          </div>
          :
          <div className='gap-7 w-fit justify-between mx-auto mt-7 flex flex-wrap'>
            {
              property.length === 0 ?
                <div className={'flex flex-1 flex-col justify-center items-center h-full w-full'}>
                  {/*<Home />*/}
                  <p className={'font-bold text-sm py-4'}>No Property Yet</p>
                </div> :
                property?.map((investment: User, index) => {
                  return (
                <Link to={`/app/properties/${investment?.id}`} key={index}
                      className='rounded-3xl overflow-hidden w-[305px] sm:w-[200px] md:w-[305px] bg-white border border-custom-grey'>
                  <div className='relative'>
                    <img src={`${StorageBaseURL}${investment?.thumbnail}`}  alt='investment'
                         className='w-full h-44 bg-green-200' />
                    <span
                      className={`absolute uppercase bg-white top-2 font-semibold left-2 rounded-full text-xs py-1 px-2.5 ${investment?.property?.available_slots === 0 ? 'text-red-500' : 'text-green-600'}`}>
                          {investment?.status === 0 ? 'Rent' : 'Active'}
                        </span>
                  </div>
                  <div className='p-3'>
                    <div className={'flex gap-2 py-2'}>
                        <span
                          className={'bg-[#E5E5E5] flex justify-between gap-3 py-1 px-2.5 w-fit rounded-3xl items-center text-xs'}>
                          <span>
                            <Bed />
                          </span>
                          <span>{investment?.rooms}</span>
                        </span>
                      <span
                        className={'bg-[#E5E5E5] flex justify-between gap-3 py-1 px-2.5 w-fit rounded-3xl items-center text-xs'}>
                            <span>
                              <Shower />
                            </span>
                            <span>{investment?.showers}</span>
                          </span>
                      <span
                        className={'bg-[#E5E5E5] flex justify-between gap-3 py-1 px-2.5 w-fit rounded-3xl items-center text-xs'}>
                            <span>
                              <Toilet />
                            </span>
                            <span>{investment?.toilets}</span>
                          </span>
                    </div>
                    <h1 className='py-2'>{investment?.title}</h1>
                    <div className={'flex justify-between bg-[#F9F9F9] text-sm rounded-lg py-2 px-2.5'}>
                      <h1>Property Price: </h1>
                      <p>{formatCurrency(Number(investment?.fixed_amount))}</p>
                    </div>
                  </div>
                </Link>
                  );
                })}
          </div>
        }
        {
          property.length === 0 ?
            <div>
            </div> :
            <div className={'py-12 flex justify-end'}>
              <Pagination paginate={paginate} getPropertyCoOwnData={getBuyProperties} />
            </div>
        }

      </div>
    </div>
  );
}

export default Buy;
